import React from 'react';

export default class Sidebar extends React.Component {

  render() {
    const { children, outOfScrollChildren } = this.props;

    return (
      <div className="sidebar" id="sidebar">
        <div className="sidebar-content scroll-natif" id="wrapper2">
          {
            children
          }
        </div>
        {
          outOfScrollChildren
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/sidebar/Sidebar.jsx